import { DocStructure } from '../services/docs/models/doc-structure';

export const DOCS_STRUCTURE: DocStructure = {
  sections: [
    {
      id: 'getting-started',
      title: 'Começando',
      icon: 'rocket',
      children: [
        {
          id: 'intro',
          title: 'Introdução',
          path: '/assets/docs/getting-started/intro.md'
        },
        {
          id: 'first-steps',
          title: 'Primeiros Passos',
          path: '/assets/docs/getting-started/first-steps.md'
        },
        {
          id: 'interface',
          title: 'Interface e permissões',
          path: '/assets/docs/getting-started/interface.md'
        }
      ]
    },
    {
      id: 'operation',
      title: 'Operação',
      icon: 'calendar_view_week',
      children: [
        {
          id: 'home',
          title: 'Home',
          path: '/assets/docs/operation/home.md'
        },
        {
          id: 'weekly-allocations',
          title: 'Alocação',
          path: '/assets/docs/operation/weekly-allocations.md'
        },
        {
          id: 'collaborators',
          title: 'Colaboradores',
          path: '/assets/docs/operation/collaborators.md'
        },
        {
          id: 'projects',
          title: 'Projetos',
          path: '/assets/docs/operation/projects.md'
        },
        {
          id: 'teams',
          title: 'Verticais Tecnológicas',
          path: '/assets/docs/operation/teams.md'
        },
        {
          id: 'job-positions',
          title: 'Funções',
          path: '/assets/docs/operation/job-positions.md'
        }
      ]
    },
    {
      id: 'reports',
      title: 'Relatórios',
      icon: 'analytics',
      children: [
        {
          id: 'projects-report',
          title: 'Dashboard de projetos',
          path: '/assets/docs/reports/projects-report.md'
        }
      ]
    },
    {
      id: 'account',
      title: 'Conta',
      icon: 'person',
      children: [
        {
          id: 'auth',
          title: 'Acesso ao sistema',
          path: '/assets/docs/account/auth.md'
        },
        {
          id: 'profile',
          title: 'Meu perfil',
          path: '/assets/docs/account/profile.md'
        }
      ]
    },
    {
      id: 'system',
      title: 'Sistema',
      icon: 'settings',
      children: [
        {
          id: 'users',
          title: 'Usuários',
          path: '/assets/docs/system/users.md'
        }
      ]
    }
  ]
};
